<template>
  <div class="info-bubble" @mouseenter="show = true" @mouseleave="show = false">
    <ion-icon name="help-circle" />
    <div class="info-bubble-container">
      <transition name="fade" mode="out-in">
        <div v-if="show" class="bubble">
          <div v-if="title" class="title">
            <ion-icon name="help-circle" />
            <span> {{ title }}</span>
          </div>
          <p>{{ text }}</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoBubble',
  data: () => ({
    show: false
  }),
  props: {
    title: String,
    text: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.info-bubble {
  [name='help-circle'] {
    font-size: 18px;
    color: var(--purple-light-3);
    cursor: pointer;
  }

  .info-bubble-container {
    .bubble {
      width: 240px;
      padding: 12px;
      margin-left: 6px;
      position: absolute;
      top: 1px;
      border-radius: 13px;
      background: #fff;
      box-shadow: 0 20px 40px #071c4e33;
      z-index: 100;
      transition: 0.3s ease-out;
      -webkit-animation: slideUp 0.2s ease;
      animation: slideUp 0.2s ease;

      [name='help-circle'] {
        font-size: 18px;
        color: var(--primary-color);
        cursor: pointer;
        margin-right: 4px;
      }

      .title {
        display: flex;
        align-items: center;
      }

      p {
        padding: 4px 0;
        font-size: 13px;
        font-weight: 500;
        line-height: 16px;
        color: var(--primary-color);
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.3s ease-out;
    }

    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
